import { PaymentDropInClassNames } from '@accedo/one-plugin-sdk';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';

import { PageSpinner } from '#/components/Splash';
import { remify } from '#/service/utils';

import { PaymentFormProps } from './types';

interface ContainerProps {
  /** If the drop-in is at the very bottom of the view, add some extra bottom margin. */
  $isAtBottom?: boolean;
}

const Container = styled.div<ContainerProps>`
  position: relative;
  display: flex;
  justify-content: center;
  text-align: initial;
  min-height: 20rem;
  border-radius: ${remify(8)};
  overflow: hidden;
  margin-bottom: ${({ $isAtBottom }) => remify($isAtBottom ? 48 : 0)};
`;

export const DropInContainer = ({ isAtBottom }: { isAtBottom?: boolean }) => (
  <Container
    $isAtBottom={isAtBottom}
    className={PaymentDropInClassNames.Container}
    data-testid="drop-in-container"
  >
    <PageSpinner
      $startFadeout={false}
      className={PaymentDropInClassNames.Spinner}
    />
  </Container>
);

const PaymentDropInForm = ({
  onPurchase,
  onSuccess,
  onFailure,
}: PaymentFormProps) => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    // no matter what dependency has changed, we only want to start this once.
    if (!isFirstRender.current) {
      return;
    }
    isFirstRender.current = false;
    onPurchase({}).then(onSuccess).catch(onFailure);
  }, [onFailure, onPurchase, onSuccess]);

  return <DropInContainer isAtBottom />;
};

export default PaymentDropInForm;
